import Immutable from 'immutable';
import { RawUser, User } from 'records/User';

export type SortDirection = 'ascending' | 'descending';

export interface RawRFIQuery {
  open: boolean; // True -> filter out open RFIs, False -> show all RFIs
  closed: boolean;
  drafts: boolean;
  overdue: Immutable.Set<number>;
  assignees: Immutable.Set<RawUser>;
  pages: Immutable.Set<string> | null; // sheetversion.pageid
  sortField: string; // would be nice to have this as an enum.
  sortDirection: SortDirection;
  search: string;
}

export interface RFIQueryData {
  open: boolean;
  closed: boolean;
  drafts: boolean;
  overdue: Immutable.Set<number>;
  assignees: Immutable.Set<User>;
  pages: Immutable.Set<string> | null;
  sortField: string;
  sortDirection: SortDirection;
  search: string;
}

const defaultValues: RFIQueryData = {
  open: false,
  closed: false,
  drafts: false,
  overdue: Immutable.Set<number>(),
  assignees: Immutable.Set<User>(),
  pages: null,
  sortField: 'number',
  sortDirection: 'descending',
  search: '',
};

export const RFIQueryFactory = Immutable.Record(defaultValues, 'RFIQuery');

export class RFIQuery extends RFIQueryFactory {
  static deserialize(rawRFIQuery: RawRFIQuery): RFIQuery {
    return new RFIQuery({
      ...rawRFIQuery,
      overdue: Immutable.Set(rawRFIQuery.overdue),
      assignees: Immutable.Set(rawRFIQuery.assignees.map(User.deserialize)),
    });
  }

  serialize(): RawRFIQuery {
    return this.toJS();
  }

  filterApplied(): boolean {
    const { assignees, overdue, open, closed } = this;

    return assignees.size > 0 || overdue.size > 0 || open || closed;
  }
}
